export default {
  nav: {
    home: 'Home',
    products: 'All Products',
    categories: 'Categories',
    about: 'About Us',
    contact: 'Contact',
    trackService: 'Track Service',
    trackOrder: 'Track Order',
    login: 'Login',
  },
  titles: {
    home: 'Home',
    products: 'All Products',
    productDetail: 'Product Detail',
    category: 'Category',
    cart: 'Shopping Cart',
    checkout: 'Checkout',
    search: 'Search',
    wishlist: 'Wishlist',
    about: 'About Us',
    contact: 'Contact Us',
    login: 'Login',
    register: 'Register',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    returns: 'Return Policy',
    delivery: 'Delivery Information',
    account: 'My Account',
    orderSuccess: 'Order Confirmed',
    trackService: 'Track Service',
    bookService: 'Book Service',
    forgotPassword: 'Reset Password',
    signingIn: 'Signing in...',
  },
  header: {
    searchPlaceholder: 'Search products...',
    searchPlaceholderMobile: 'Search...',
    profile: 'Profile',
    login: 'Login',
    account: 'Account',
    register: 'Register',
    wishlist: 'Wishlist',
    cart: 'Cart',
    freeShipping: '🚚 Free shipping over {threshold} {currency}',
  },
  footer: {
    description: 'Your destination for electronics, parts and professional service. Quality products at affordable prices.',
    quickLinks: 'Quick Links',
    allProducts: 'All Products',
    help: 'Help',
    delivery: 'Delivery',
    returns: 'Returns',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    contact: 'Contact',
    contactInfo: 'Contact',
    workingHours: 'Mon-Sat: 09:00 - 20:00',
    paymentMethods: 'Payment Methods:',
    securePayment: '🔒 Secure Payment',
    fastDelivery: '🚚 Fast Delivery',
    returnPolicy: '↩️ 14 Day Returns',
    allRightsReserved: 'All rights reserved.',
    termsShort: 'Terms',
    privacyShort: 'Privacy',
    returnsShort: 'Returns',
    deliveryShort: 'Delivery',
  },
  home: {
    heroTitle: 'Best Electronics in One Place',
    heroSubtitle: 'Quality products, repair parts and professional service. Delivery throughout Macedonia.',
    shopNow: 'Shop Now',
    featuredProducts: 'Featured Products',
    categories: 'Categories',
    whyChooseUs: 'Why Choose Us?',
    quality: 'Quality',
    qualityDesc: 'Only verified products from trusted suppliers',
    fastDelivery: 'Fast Delivery',
    fastDeliveryDesc: 'Delivery throughout Macedonia in 24-48 hours',
    support: 'Support',
    supportDesc: 'Professional team available 24/7',
    warranty: 'Warranty',
    warrantyDesc: 'Warranty on all products and services',
    freeShipping: 'Free Shipping',
    freeShippingOver: 'over {threshold} {currency}',
    securePayment: 'Secure Payment',
    sslProtection: 'SSL Protection',
    returnPolicy: '14 Days Return',
    noQuestions: 'no questions',
    support247: 'Support 24/7',
    hereForYou: 'we\'re here for you',
    products: 'products',
    needService: 'Need Service?',
    serviceDescription: 'Bring your device for free diagnosis. Professional repair with warranty.',
    bookService: 'Book Service',
  },
  service: {
    title: 'Book Service',
    subtitle: 'Choose the service you need and we will get back to you as soon as possible.',
    selectService: 'Select Service',
    repair: 'Repair Service',
    review: 'Product Review',
    sell: 'Sell Your Product',
    showcase: 'Showcase Product',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    description: 'Description / Details',
    descriptionPlaceholder: 'Describe the issue with your device...',
    tellUsMore: 'Tell us more...',
    submitRequest: 'Submit Request',
    sendingRequest: 'Sending Request...',
  },
  category: {
    notFound: 'Category not found',
    productsCount: 'products',
    empty: 'No products in this category',
  },
  products: {
    title: 'All Products',
    items: 'products',
    noProducts: 'No products available',
    noProductsFound: 'No products found',
    loading: 'Loading...',
    addToCart: 'Add to Cart',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    price: 'Price',
    minPrice: 'Min',
    maxPrice: 'Max',
    viewDetails: 'View Details',
    viewAll: 'View All',
    search: 'Search',
    searchPlaceholder: 'Search products...',
    categories: 'Categories',
    allCategories: 'All Categories',
    sortBy: 'Sort By',
    sortByName: 'By Name',
    sortByPrice: 'By Price',
    sortByDate: 'By Date',
    sortAscending: 'Ascending',
    sortDescending: 'Descending',
    previous: 'Previous',
    next: 'Next',
    page: 'Page {current} of {total}',
  },
  product: {
    addToCart: 'Add to Cart',
    added: 'Added',
    reviews: 'Reviews',
    reviewsComingSoon: 'Reviews Coming Soon',
    reviewsDesc: 'Customer reviews feature is coming soon to our store.',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    quantity: 'Quantity',
    description: 'Description',
    specifications: 'Specifications',
    relatedProducts: 'Related Products',
    stock: 'Stock',
    showStock: 'Show Stock',
    hideStock: 'Hide Stock',
    sku: 'SKU',
    barcode: 'Barcode',
    includesTax: 'includes VAT',
    priceWithoutTax: 'Price without VAT',
    pieces: 'pieces',
    fastDelivery: 'Fast Delivery',
    deliveryDays: '1-3 days',
    warranty: 'Warranty',
    warrantyMonths: '12 months',
    returns: 'Returns',
    returnDays: '14 days',
    freeShipping: 'Free Shipping!',
    shipping: 'Shipping',
    qualifiesForFreeShipping: 'Your order qualifies for free shipping',
    addMoreForFreeShipping: 'Add {amount} more for free shipping',
    total: 'Total',
    acceptedPaymentMethods: 'Accepted Payment Methods',
    cash: 'Cash',
    card: 'Card',
    bankTransfer: 'Bank Transfer',
    mobilePayment: 'Mobile Payment',
    noDescription: 'No description available for this product.',
    unit: 'Unit',
    piece: 'Piece',
    category: 'Category',
    locations: 'Locations',
    addedToCart: 'Product added to cart!',
    vat: 'VAT',
  },
  cart: {
    title: 'Cart',
    empty: 'Your cart is empty',
    continueShopping: 'Continue Shopping',
    subtotal: 'Subtotal',
    tax: 'Tax',
    total: 'Total',
    checkout: 'Checkout',
    remove: 'Remove',
    emptyCart: 'Empty Cart',
    shipping: 'Shipping',
    free: 'Free',
    freeShippingMessage: 'Add {amount} more for free shipping',
    proceedToCheckout: 'Proceed to Checkout',
    summary: 'Order Summary',
  },
  checkout: {
    title: 'Checkout',
    shippingInfo: 'Shipping Information',
    paymentMethod: 'Payment Method',
    orderSummary: 'Order Summary',
    placeOrder: 'Place Order',
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    notes: 'Notes (optional)',
    cash: 'Cash',
    card: 'Card',
    bankTransfer: 'Bank Transfer',
    mobilePayment: 'Mobile Payment',
    thankYou: 'Thank you for your order!',
    orderConfirmed: 'Your order #{orderNumber} has been confirmed.',
    confirmationEmail: 'We have sent a confirmation email with all the details.',
    guestCheckout: 'Guest Checkout',
    guestCheckoutDesc: 'You can checkout without creating an account. We\'ll send order confirmation to your email.',
  },
  about: {
    title: 'About Us',
    defaultDescription: 'Welcome to {storeName}!',
    defaultContent: 'We are committed to providing the best products and services to our customers.',
    contactInfo: 'Contact Information',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    followUs: 'Follow Us',
    subtitle: 'Your trusted partner in electronics and technology solutions.',
    socialDescription: 'Stay updated with our latest offers and news by following us on social media.',
    qualityTitle: 'Quality Guarantee',
    qualityDesc: 'We ensure 100% authentic products directly from certified manufacturers.',
    deliveryTitle: 'Fast Delivery',
    deliveryDesc: 'Reliable shipping partners ensuring your orders reach you on time.',
    secureTitle: 'Secure Payment',
    secureDesc: 'Your transactions are protected with industry-leading security standards.',
  },
  contact: {
    title: 'Contact',
    getInTouch: 'Get in Touch',
    sendMessage: 'Send Message',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    send: 'Send Message',
    phone: 'Phone',
    address: 'Address',
    subtitle: 'We are here to help and answer any question you might have.',
    success: 'Your message has been sent successfully! We will contact you shortly.',
    sending: 'Sending...',
  },
  search: {
    title: 'Search Results',
    query: 'Searching for: "{query}"',
    noResults: 'No results found for "{query}"',
    tryAgain: 'Try different keywords',
    enterTerm: 'Please enter a search term',
  },
  register: {
    title: 'Register',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    phonePlaceholder: '+389 7X XXX XXX',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    passwordsDoNotMatch: 'Passwords do not match',
    marketingConsent: 'I want to receive marketing messages',
    submit: 'Register',
    registering: 'Registering...',
    success: 'Registration successful!',
    error: 'Registration error',
    alreadyHaveAccount: 'Already have an account?',
    backToHome: 'Back to Home',
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    submit: 'Login',
    loggingIn: 'Logging in...',
    error: 'Invalid email or password',
    noAccount: "Don't have an account?",
    registerHere: 'Register here',
    successMessage: 'You are logged in now.',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot your password?',
    orContinueWith: 'Or continue with',
    signInWithGoogle: 'Sign in with Google',
    signInWithFacebook: 'Sign in with Facebook',
  },
  account: {
    title: 'My Account',
    welcome: 'Welcome, {name}',
    completeProfileMessage: 'Please add your phone number to complete your profile.',
    details: 'Account Details',
    logout: 'Logout',
    orders: 'Order History',
    noOrders: 'No orders yet.',
    orderNumber: 'Order Number',
    date: 'Date',
    total: 'Total',
    cancelOrder: 'Cancel Order',
    confirmCancel: 'Are you sure you want to cancel this order?',
    orderCancelled: 'Order cancelled successfully',
    profile: 'Profile',
    addresses: 'Addresses',
    security: 'Security',

    // Address form
    addressName: 'Address Name (e.g. Home)',
    streetAddress: 'Street Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    defaultShippingAddress: 'Default Shipping Address',
    setAsDefault: 'Set as default shipping address',
    editAddress: 'Edit Address',
    newAddress: 'New Address',
    addAddress: 'Add New',
    addressUpdated: 'Address updated',
    addressCreated: 'Address created',
    addressDeleted: 'Address deleted',
    deleteAddressConfirm: 'Are you sure you want to delete this address?',
    saveChanges: 'Save Changes',
    notificationPreferences: 'Notification Preferences',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    whatsappNotifications: 'WhatsApp Notifications',
    profileUpdated: 'Profile updated successfully',
    passwordChanged: 'Password changed successfully',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    changePassword: 'Change Password',
  },
  forgotPassword: {
    title: 'Reset Password',
    subtitle: "Enter your email address and we'll send you a link to reset your password.",
    email: 'Email Address',
    submit: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: 'Back to Login',
    success: 'Reset link sent! Please check your email.',
    error: 'Failed to send reset link. Please try again.',
  },
  common: {
    loading: 'Loading...',
    error: 'Error',
    tryAgain: 'Try Again',
    back: 'Back',
    close: 'Close',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    yes: 'Yes',
    no: 'No',
    currency: 'MKD',
    language: 'Language',
    continueShopping: 'Continue Shopping',
    track: 'Track',
    select: 'Select',
    previous: 'Previous',
    next: 'Next',
    fillRequiredFields: 'Please fill in all required fields',
    required: 'Required',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone number',
    pageOf: 'Page {current} of {total}',
    processing: 'Processing...',
    noData: 'No data available',
  },
  track: {
    title: 'Track Your Service',
    subtitle: 'Enter your service ID or tracking number to see the status.',
    placeholder: 'e.g. SRV-12345',
    notFound: 'Service order not found',
    details: 'Service Details',
    date: 'Date',
    estimatedCompletion: 'Est. Completion',
  },
  wishlist: {
    title: 'My Wishlist',
    empty: 'Your wishlist is empty',
    emptyMessage: 'Save items you love to review them later.',
    addToWishlist: 'Add to wishlist',
    removeFromWishlist: 'Remove from wishlist',
    removed: 'Removed from wishlist',
    added: 'Added to wishlist',
  },
  serviceStatus: {
    received: 'Received',
    diagnosing: 'Diagnosing',
    waiting_approval: 'Waiting Approval',
    approved: 'Approved',
    in_progress: 'In Progress',
    waiting_parts: 'Waiting for Parts',
    ready: 'Ready',
    delivered: 'Picked Up',
    cancelled: 'Cancelled',
  },
  policies: {
    common: {
      lastUpdated: 'Last updated: {date}',
      contact: {
        title: 'Contact',
        text: 'For questions, please contact us:',
        hours: 'Working hours: Monday - Friday: 09:00 - 18:00, Saturday: 09:00 - 14:00'
      }
    },
    delivery: {
      title: 'Delivery Policy',
      intro: 'We deliver orders throughout the entire territory of the Republic of North Macedonia. We work with trusted courier companies to ensure safe and timely delivery.',
      areas: {
        title: '1. Delivery Areas',
        skopje: { title: 'Skopje and surroundings', text: 'Standard delivery: 1-2 working days' },
        other: { title: 'Other cities', text: 'Standard delivery: 2-4 working days' },
        remote: { title: 'Remote areas', text: 'Standard delivery: 3-5 working days' },
        express: { title: 'Express Delivery', text: 'Available for selected areas: 24 hours' }
      },
      time: {
        title: '2. Processing and Delivery Time',
        processingTitle: 'Order Processing',
        processingList: [
          'Orders are processed within 1-2 working days',
          'Orders received before 14:00 are processed the same day',
          'Orders received after 14:00 are processed the next working day',
          'During holidays and weekends, processing may be delayed'
        ],
        deliveryTitle: 'Delivery Time',
        deliveryList: [
          'Delivery time is calculated from the moment of dispatch',
          'Working days are Monday to Friday (excluding public holidays)',
          'You will receive an SMS or email with shipment information',
          'You can track your shipment with the tracking number'
        ]
      },
      costs: {
        title: '3. Delivery Costs',
        freeTitle: 'Free Delivery',
        freeText: 'Free delivery is available for orders over {amount} MKD.',
        standardTitle: 'Standard Delivery',
        standardList: [
          'Skopje and surroundings: 150 - 250 MKD',
          'Other cities: 200 - 350 MKD',
          'Remote areas: 300 - 500 MKD',
          'Exact costs are shown at checkout'
        ],
        expressTitle: 'Express Delivery',
        expressText: 'Express delivery (24 hours) is available for selected areas. Costs are shown at checkout.'
      },
      methods: {
        title: '4. Delivery Methods',
        home: { title: 'Home Delivery', text: 'The courier will bring the product to your address. Please ensure address accuracy and presence during delivery.' },
        box: { title: 'PO Box Delivery', text: 'You can choose delivery to a PO Box at a selected location. You will be notified when the shipment is ready.' },
        store: { title: 'Store Pickup', text: 'You can pick up the product from our store. We will notify you when the order is ready.' },
        work: { title: 'Workplace Delivery', text: 'You can order delivery to your workplace. Please provide accurate address and contact information.' }
      },
      delays: {
        title: '7. Delays and Issues',
        text1: 'While we strive to meet the stated deadlines, delays may occur due to unforeseen circumstances (bad weather, traffic issues, etc.).',
        text2: 'If your shipment is delayed more than 2 working days from the stated deadline, please contact us to check the status.'
      }
    },
    return: {
      title: 'Return Policy',
      intro: 'In accordance with the Consumer Protection Law of the Republic of North Macedonia, you have the right to cancel the ordered product within 14 calendar days from the date of receipt, without giving any reason.',
      introTitle: 'Your Right to Return',
      deadline: {
        title: '1. Return Deadline',
        text1: 'The 14-day period starts from the day you or a third party (other than the carrier) designated by you receives the product.',
        text2: 'To exercise the right of return, you must inform us of your decision via a clear statement (e.g., letter by mail, fax, or email) before the 14-day period expires.'
      },
      conditions: {
        title: '2. Return Conditions',
        mustBeTitle: 'The product must be:',
        mustBeList: [
          'In original condition, unused',
          'With original packaging and labels',
          'With all attachments and documents (if any)',
          'Without damage or signs of use'
        ],
        cannotBeTitle: 'Products that cannot be returned:',
        cannotBeList: [
          'Personalized products made to your specifications',
          'Products that spoil quickly or have a short shelf life',
          'Sealed products opened after delivery (CD, DVD, software)',
          'Products not suitable for return due to health or hygiene reasons'
        ]
      },
      process: {
        title: '3. Return Process',
        step1: { title: 'Step 1', subtitle: 'Contact Us' },
        step2: { title: 'Step 2', subtitle: 'Prepare the Product', text: 'Place the product in original packaging with all attachments and documents.' },
        step3: { title: 'Step 3', subtitle: 'Send the Product', text: 'Send it to our address.' }
      },
      costs: {
        title: '4. Return Costs',
        text1: 'If the product is defective or does not match the description: We cover all return costs.',
        text2: 'If you are returning the product without reason (within legal right): Return costs are at your expense.'
      },
      refund: {
        title: '5. Refunds',
        text1: 'We will refund the amount you paid for the product (including standard delivery costs) within 14 calendar days of receiving the returned product.',
        text2: 'The refund will be made using the same means of payment as you used for the initial transaction.',
        note: 'Note: We may deduct an amount for the reduction in value of the product if it is damaged due to your fault.'
      },
      exchange: {
        title: '6. Product Exchange',
        text: 'If you wish to exchange the product for another, please contact us. We will try to accommodate your request, provided the product is available.'
      },
      warranty: {
        title: '7. Warranty',
        text: 'This return policy does not affect your statutory warranty rights. If the product has a manufacturing defect, you have the right to repair, replacement, or refund in accordance with the manufacturer warranty.'
      }
    },
    privacy: {
      title: 'Privacy Policy',
      intro: '{storeName} is committed to protecting your privacy. This policy explains how we collect, use, store, and protect your personal data when you use our website and services.',
      introTitle: '1. Introduction',
      collection: {
        title: '2. Data We Collect',
        givenTitle: '2.1. Data You Give Us',
        givenList: ['First and Last Name', 'Email Address', 'Phone Number', 'Delivery Address', 'Payment Information'],
        autoTitle: '2.2. Automatically Collected Data',
        autoList: ['IP Address', 'Browser Type and Version', 'Visit Time and Pages Viewed', 'Cookies and Similar Technologies']
      },
      usage: {
        title: '3. How We Use Your Data',
        list: [
          'To process and deliver your orders',
          'To communicate with you regarding your orders and inquiries',
          'To improve our website and services',
          'To send marketing messages (only with your consent)',
          'To comply with legal obligations'
        ]
      },
      protection: {
        title: '4. Data Protection',
        text: 'We use industry-standard security measures to protect your personal data, including encryption, secure servers, and limited access to data only for authorized personnel.'
      },
      sharing: {
        title: '5. Data Sharing',
        text: 'We do not sell your personal data to third parties. We may share your data only with service providers (courier companies, payment processors) for fulfilling orders, or when legally required.'
      },
      rights: {
        title: '6. Your Rights',
        text: 'You have the right to:',
        list: ['Access your personal data', 'Correct inaccurate data', 'Delete your data', 'Restrict processing', 'Data portability', 'Object to processing']
      },
      cookies: {
        title: '7. Cookies',
        text: 'We use cookies to improve your experience on our website. You can control cookies through your browser settings.'
      },
      changes: {
        title: '8. Policy Changes',
        text: 'We may update this privacy policy from time to time. We will notify you of any significant changes via our website or email.'
      }
    },
    terms: {
      title: 'Terms of Use',
      lastUpdated: 'Last updated: {date}',
      section1: {
        title: '1. Acceptance of Terms',
        text: 'By accessing and using the {storeName} website, you agree to comply with these terms of use. If you do not agree with these terms, please do not use our website.'
      },
      section2: {
        title: '2. Orders and Payment',
        subsection1: {
          title: '2.1. Order Process',
          list: [
            'All orders are subject to product availability',
            'Order is considered accepted when you receive an email confirmation',
            'We reserve the right to refuse or cancel an order for any reason',
            'Prices are accurate at the time of ordering but may change without prior notice'
          ]
        },
        subsection2: {
          title: '2.2. Payment',
          list: [
            'We accept various payment methods (cash on delivery, card, bank transfer)',
            'Payment must be made before or upon delivery',
            'All prices are in MKD and include VAT',
            'We reserve the right to request additional verification for security'
          ]
        }
      },
      section3: {
        title: '3. Prices and Availability',
        list: [
          'All prices are accurate at the time of publication but may change',
          'If a product is unavailable after order acceptance, we will contact you',
          'We reserve the right to change prices without prior notice',
          'Promotional prices are valid only for a specific period or while stocks last'
        ]
      },
      section4: {
        title: '4. Delivery',
        text: 'Delivery details are available on the delivery page. Please ensure accurate delivery address. We are not responsible for delays caused by third parties (courier companies).',
        list: [
          'Delivery time is approximate and may vary',
          'Delivery costs are shown at checkout',
          'Free delivery is available for orders above a certain amount'
        ]
      },
      section5: {
        title: '5. Cancellations and Returns',
        text: 'In accordance with consumer rights, you have the right to cancel the ordered product within 14 days of receipt, without giving a reason.',
        list: [
          'Product must be in original condition, unused and with original packaging',
          'Return costs are at your expense, unless the product is defective',
          'We will refund the amount within 14 days of receiving the returned product',
          'Some products (personalized, fresh products) cannot be returned'
        ]
      },
      section6: {
        title: '6. Intellectual Property',
        text: 'All website content, including texts, images, logos, and design, are protected by copyright and are owned by {storeName}. Unauthorized copying or use is prohibited.'
      },
      section7: {
        title: '7. Liability',
        text: '{storeName} is not responsible for:',
        list: [
          'Damages caused by use or misuse of our products',
          'Delivery delays caused by third parties',
          'Technical issues or website interruptions',
          'Data loss or financial losses'
        ]
      },
      section8: {
        title: '8. Changes to Terms',
        text: 'We reserve the right to change these terms at any time. Changes will be posted on this website and are effective immediately upon posting.'
      },
      section9: {
        title: '9. Applicable Law',
        text: 'These terms are governed by the laws of the Republic of North Macedonia. All disputes will be resolved before the competent courts in North Macedonia.'
      },
      section10: {
        title: '10. Contact',
        address: 'Address',
        email: 'Email',
        phone: 'Phone'
      }
    }
  },
  whatsapp: {
    chatWithUs: 'Chat with us',
    defaultMessage: 'Hello! I have a question about your products.'
  }
}
